import { TextField } from "@material-ui/core";
import { CalendarToday } from "@material-ui/icons";
import styled from "styled-components";

export default function RuleOne({ onChange, value }) {
    return (
        <RuleContainer>
            <RuleDescription>
                <CalendarToday style={{ fontSize: '16px', marginRight: '6px', color: '#667eea' }} />
                Data + X dias
            </RuleDescription>
            <StyledTextField>
                <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    id="id"
                    name="id"
                    label="Quantidade de dias"
                    type="number"
                    placeholder="Ex: 5"
                    onChange={(e) => onChange(e.target.value)}
                    value={value}
                    autoComplete="off"
                    variant="outlined"
                />
            </StyledTextField>
        </RuleContainer>
    )
}

const RuleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const RuleDescription = styled.p`
    font-size: 13px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
    display: flex;
    align-items: center;
    font-family: 'Mulish', sans-serif;
`;

const StyledTextField = styled.div`
    .MuiOutlinedInput-root {
        border-radius: 10px;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
        }

        &.Mui-focused {
            box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
        }
    }

    .MuiOutlinedInput-input {
        font-family: 'Mulish', sans-serif;
        font-size: 14px;
    }

    .MuiInputLabel-outlined {
        font-family: 'Mulish', sans-serif;
    }
`;